import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

export const clearGig = (gigId) => {
    const url = pathfinder('delete_recently_viewed_gigs', { id: gigId });

    return axios.delete(url);
};
